import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const IconCategoryEducation = (props) => (<Svg width={props.width} height={props.height} fill="none" {...props}>
    <Path d="M9.953 2.688c-1.286-.677-3.821.63-4.55 1.782-.324.515-.3.887-.3 1.097v11.27l9.504 5.915 1.788-.976V10.8l-9.76-5.603c.524-.66 1.702-1.463 2.585-1.14l8.693 4.649v12.227l1.791-.977V7.729L9.954 2.688Z" fill={props.fill}/>
  </Svg>);
export default IconCategoryEducation;
